/**
 * Removes all whitespace characters from a given string.
 * This function takes a string as input and returns a new string with all whitespace characters removed.
 * Whitespace characters include spaces, tabs, and line breaks.
 * @param {string} str - The string from which to remove whitespace characters.
 * @returns {string} - Returns a new string with all whitespace characters removed.
 */

export const removeSpacesFromString = (str) => str.replace(/\s/g, '');
